module.exports = __webpack_public_path__ + "img/ch82.6936add1.png";